import axios from "axios";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loaderDisplayHideAction } from "../actions";
import ReactPlayer from "react-player";
import { getHeaderForAxios } from "../common/getLocalStorageData";
import { isMobileOnly } from "react-device-detect";
import "../../src/assets/css/scss/section/_videoWrapper.scss";
import { FaFastForward, FaVolumeMute, FaStepForward } from "react-icons/fa";
import { Button } from "react-bootstrap";
import EncryptData from "../common/encryption";

export default function VideoWrapper(props: any) {
  const param: any = useParams();
  const [getIdentifier] = useState(
    props?.identifier || param?.identifier || ""
  );
  const [data, setData] = useState<any[]>([]);
  const [previewImages, setPreviewImages] = useState<any[]>([]);
  const [playVideo, setPlayVideo] = useState<boolean>(false);
  const [videoMuted, setVideoMuted] = useState<boolean>(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number>(0);

  const dispatch = useDispatch();
  const loaderDisplayHideRedux = useCallback(
    (data) => {
      dispatch(loaderDisplayHideAction(data));
    },
    // eslint-disable-next-line
    [dispatch]
  );

  const headerContainer = document
    .getElementById("header-container")
    ?.getBoundingClientRect();
  const headerWhiteContainer = document
    .getElementById("header-white-container")
    ?.getBoundingClientRect();
  const footerContainer = document
    .getElementById("footer-container")
    ?.getBoundingClientRect();

  const fetchSiteSetting = () => {
    loaderDisplayHideRedux({ isFullScreenLoaderDisplay: true });
    const dataHeader = {
      identifier: getIdentifier,
    };
    axios
      .post(
        process.env.REACT_APP_API_URL + "/common/get-site-video",
        dataHeader,
        { headers: getHeaderForAxios() }
      )
      .then(function (response) {
        if (response.data.success) {
          const res = response.data.success;
          if (res["urls"]) {
            const findData: any[] = res["urls"].split(",");
            const findImageData: any[] = res?.preview_urls
              ? res?.preview_urls.split(",")
              : [];
            if (Array.isArray(findData) && findData.length) {
              setData(findData);
            } else {
              setData([]);
            }
            setPreviewImages(findImageData);
          } else {
            setData([]);
            setPreviewImages([]);
          }
          loaderDisplayHideRedux({
            isFullScreenLoaderDisplay: false,
          });
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        loaderDisplayHideRedux({ isFullScreenLoaderDisplay: false });
      });
  };

  useEffect(() => {
    if (getIdentifier) {
      fetchSiteSetting();
    }
  }, [getIdentifier]);

  useEffect(() => {
    if (props?.autoplay) {
      setPlayVideo(true);
    }
  }, []);

  const hideVideo = () => {
    localStorage.removeItem("displayIntro");
    if (props?.hideFn) {
      props.hideFn();
    }
    localStorage.setItem("intoVideoDisplayed", EncryptData("true"));
    window?.location?.reload();
  };

  const handleVideoEnded = () => {
    // If there are more videos, go to next one
    if (currentVideoIndex < data.length - 1) {
      setCurrentVideoIndex(currentVideoIndex + 1);
      setPlayVideo(true); // Continue playing the next video
    } else {
      // If it's the last video, hide the video wrapper
      hideVideo();
    }
  };

  const handleNextVideo = () => {
    if (currentVideoIndex < data.length - 1) {
      setCurrentVideoIndex(currentVideoIndex + 1);
      setPlayVideo(true);
    } else {
      hideVideo();
    }
  };

  const getCurrentPreviewImage = () => {
    if (previewImages.length === 0) return false;

    // If we have multiple preview images, use the corresponding one for current video
    if (previewImages.length > currentVideoIndex) {
      return isMobileOnly
        ? previewImages[currentVideoIndex * 2 + 1] ||
            previewImages[currentVideoIndex]
        : previewImages[currentVideoIndex];
    }

    // Fallback to first preview image
    return isMobileOnly
      ? previewImages[1] || previewImages[0]
      : previewImages[0];
  };

  return (
    <Fragment>
      {data.length ? (
        <div className="video-player-wrapper" id="video-player-id">
          <div
            className="position-relative video-player-bottom-wrapper"
            onClick={() => setPlayVideo(!playVideo)}
          >
            <ReactPlayer
              key={currentVideoIndex} // Force re-render when video changes
              url={data[currentVideoIndex]}
              width={"100%"}
              style={{
                paddingTop:
                  headerContainer?.height ||
                  headerWhiteContainer?.height ||
                  0 + "px",
                paddingBottom:
                  headerContainer?.height ||
                  headerWhiteContainer?.height ||
                  0 + "px",
                backgroundColor: "black",
              }}
              height={
                headerWhiteContainer && headerWhiteContainer?.height
                  ? window.innerHeight - headerWhiteContainer?.height + "px"
                  : window.innerHeight + "px"
              }
              playing={playVideo}
              light={props?.autoplay ? false : getCurrentPreviewImage()}
              controls={false}
              muted={videoMuted}
              onEnded={handleVideoEnded}
              onClickPreview={() => setPlayVideo(true)}
              youtubeconfig={{
                playerVars: {
                  rel: 0,
                  showinfo: 0,
                  ecver: 2,
                  iv_load_policy: 3,
                  mute: 1,
                },
              }}
            />
          </div>
          <div className="position-absolute video-player-top-wrapper">
            <div
              key={videoMuted ? "0" : "1"}
              className="theme-white video-player-vloume-icon p-1"
              onClick={() => {
                setVideoMuted(!videoMuted);
              }}
            >
              {videoMuted ? (
                <FaVolumeMute className="icon" />
              ) : (
                <i className="fa fa-volume-up icon" aria-hidden="true" />
              )}
            </div>

            <div className="video-player-skip-button">
              {/* Skip Video Button - only show on last video */}
              {props?.isSkipInfoDisplay &&
              (data.length === 1 || currentVideoIndex === data.length - 1) ? (
                <Button
                  type="button"
                  className="font-semibold btn btn-save d-inline px-2 rounded"
                  onClick={(e) => {
                    hideVideo();
                  }}
                >
                  Skip Video <FaFastForward />
                </Button>
              ) : null}

              {/* Next Video Button - only show if there are more videos */}
              {data.length > 1 && currentVideoIndex < data.length - 1 ? (
                <Button
                  type="button"
                  className="font-semibold btn btn-primary d-inline px-2 rounded ml-2"
                  onClick={handleNextVideo}
                >
                  Next <FaStepForward />
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
}
